// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"26517":"2d68c95568455c03","34653":"cd7b41d03cecd1d6","48803":"d26ead37153d483a"}[chunkId] + ".css";
};